/* eslint-disable @typescript-eslint/no-explicit-any */
import { IActionPlanSummary } from '../anomaly/AnomalyService';
import { AuthService } from '../auth/AuthService';
import { ApiBack } from '../axios-config';

export interface IActionPlanData {
	id_anomalia: string; 
	codigo_anomalia: string; 
	descricaoAnomalia: string; 
	dataRelatorioInspecao: string;
	npa: string; 
	acao: string;
	descricao: string; 
	data_limite_seguranca?: string;
	responsavel_principal?: string;
	finalizado?: boolean; 
	uuid?: string; 
	origem?: string;
	status?: 'NAO INICIADO' | 'EM ANDAMENTO' | 'FINALIZADO';
}

interface IActionPlanBackendPayload {
	acao: string;
	data_limite_seguranca?: string;
	npa: string;
	responsavel_principal?: string;
	codigo_anomalia: string; 
	descricao: string; 
	finalizado?: string; 
	origem?: string;
	status?: string;
}

const create = async (
	uuidAnomaliaDetalhe: string, 
	data: IActionPlanData 
): Promise<IActionPlanData | Error> => {
	await AuthService.verify();

	try {
		const token = await AuthService.getAccessToken();

		const payload: IActionPlanBackendPayload = {
			acao: data.acao,
			data_limite_seguranca: data.data_limite_seguranca,
			npa: data.npa,
			responsavel_principal: data.responsavel_principal,
			codigo_anomalia: data.codigo_anomalia,
			descricao: data.descricao,
			finalizado: data.finalizado ? 'TRUE' : 'FALSE',
			origem: data.origem,
			status: data.status,
		};

		const response = await ApiBack.post(
			`./plano-acao?uuid=${uuidAnomaliaDetalhe}`, 
			JSON.stringify(payload),
			{
				headers: {
					'Content-Type': 'application/json',
					Authorization: `${token}`,
				},
			}
		);

		if (response.data) {
			const receivedData = response.data;
			return {
				...receivedData,
				// finalizado: receivedData.finalizado?.toUpperCase() === 'TRUE',
			};
		}

		return new Error('Erro ao criar plano de ação: Resposta sem dados.');
	} catch (error) {
		return new Error(
			(error as { message: string }).message || 'Erro ao criar plano de ação.'
		);
	}
};

const getById = async (
	uuidIdentificador: string 
): Promise<IActionPlanData | Error> => {
	await AuthService.verify();

	try {
		const token = await AuthService.getAccessToken();

		const response = await ApiBack.get(
			`./plano-acao?uuid=${uuidIdentificador}`, 
			{
				headers: {
					Authorization: `${token}`,
				},
			}
		);

		if (response.data) {
			if (Array.isArray(response.data) && response.data.length > 0) {
				return response.data[0];
			}
			return response.data;
		}

		return new Error('Erro ao buscar plano de ação: Resposta sem dados.');
	} catch (error) {
		return new Error(
			(error as { message: string }).message || 'Erro ao buscar plano de ação.'
		);
	}
};

const update = async (
	uuidDoPlanoDeAcao: string, 
	data: IActionPlanData 
): Promise<IActionPlanData | Error> => {
	await AuthService.verify();

	try {
		const token = await AuthService.getAccessToken();

		const payload: IActionPlanBackendPayload = {
			acao: data.acao,
			data_limite_seguranca: data.data_limite_seguranca,
			npa: data.npa,
			responsavel_principal: data.responsavel_principal,
			codigo_anomalia: data.codigo_anomalia,
			descricao: data.descricao,
			finalizado: data.finalizado ? 'TRUE' : 'FALSE',
			status: data.status,
		};

		const response = await ApiBack.put(
			`./plano-acao?uuid=${uuidDoPlanoDeAcao}`,
			JSON.stringify(payload),
			{
				headers: {
					'Content-Type': 'application/json',
					Authorization: `${token}`,
				},
			}
		);

		if (response.data) {
			const receivedData = response.data;

			let finalizadoStatus: boolean;

			if (typeof receivedData.finalizado === 'boolean') {
				finalizadoStatus = receivedData.finalizado;
			}
			else if (typeof receivedData.finalizado === 'string') {
				finalizadoStatus = receivedData.finalizado.toUpperCase() === 'TRUE';
			}
			else if (typeof receivedData.finalizado === 'number') {
				finalizadoStatus = receivedData.finalizado === 1; 
			}
			else {
				finalizadoStatus = false;
			}

			return {
				...receivedData,
				finalizado: finalizadoStatus,
			};
		} else {
			return data; 
		}
	} catch (error) {
		return new Error(
			(error as { message: string }).message ||
				'Erro ao atualizar plano de ação.'
		);
	}
};

const deletePlan = async (uuidDoPlanoDeAcao: string): Promise<void | Error> => {
    await AuthService.verify();

    try {
        const token = await AuthService.getAccessToken();

        const response = await ApiBack.delete<void>(
            `./plano-acao?uuid=${uuidDoPlanoDeAcao}`, 
            {
                headers: {
                    Authorization: `${token}`,
                },
            }
        );

        if (response.status === 200 || response.status === 204) {
            return; 
        }

        return new Error('Erro ao deletar plano de ação: Resposta inesperada do servidor.');
    } catch (error) {
        return new Error(
            (error as { message: string }).message || 'Erro ao deletar plano de ação.'
        );
    }
};


const listPlanos = async (uuid_barragem: string ): Promise<IActionPlanSummary[] | Error> => {

	await AuthService.verify();

	try {
		const token = await AuthService.getAccessToken();

		const response = await ApiBack.get(
			`./barragem-planos-acao?uuid=${uuid_barragem}`, 
			{
				headers: {
					Authorization: `${token}`,
				},
			}
		);

		if (response.data) {
			return response.data;
		}

		return new Error('Erro ao buscar plano de ação: Resposta sem dados.');
	} catch (error) {
		return new Error(
			(error as { message: string }).message || 'Erro ao buscar plano de ação.'
		);
	}
};

function mapperStatus(status: string | undefined) {
	switch (status) {
		case 'NAO INICIADO':
			return 'Não iniciado';
		case 'EM ANDAMENTO':
			return 'Em andamento';
		case 'FINALIZADO':
			return 'Finalizado';
		default:
			return 'Não iniciado';
	}
}

export const PlanosDeAcaoService = {
	create,
	getById,
	update,
    delete: deletePlan,
	listPlanos,
	mapperStatus
};
